import gql from 'graphql-tag';

export const registerRemoveFromPeriodRequestProcedure = gql`
  mutation registerRemoveFromPeriodProcedure(
    $procedureId: Float!
    $reason: String!
    $detail: String!
    $contact: String!
    $idDetail2: Float!
    $detail2: String!
    $period: String!
    $career: String!
  ) {
    registerRemoveFromPeriodProcedure(
      dataRequest: {
        procedureId: $procedureId
        reason: $reason
        detail: $detail
        contact: $contact
        idDetail2: $idDetail2
        detail2: $detail2
        period: $period
        career: $career
      }
    ) {
      error
      requestId
    }
  }
`;
